import * as firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyDajsCJUGwr9RKrlvDxoRZVHDMQEmjlHFg",
  authDomain: "letit-live.firebaseapp.com",
  projectId: "letit-live",
  storageBucket: "letit-live.appspot.com",
  messagingSenderId: "316579771138",
  appId: "1:316579771138:web:5e9c7bfd99f5c7c440481b",
  measurementId: "G-8J31MGXV8B",
};
firebase.initializeApp(firebaseConfig);
export const authRef = firebase.auth();



// WEBPACK FOOTER //
// ./src/reference.js